import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import defaultThemes from '../../shared/editor/DefaultThemes';
import TextInput from '../../shared/inputs/TextInput';
import Pagination from '../../shared/Pagination';
import Theme from './components/Theme';
import { Helmet } from 'react-helmet';

class ThemesPage extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.loadThemes = this.loadThemes.bind(this);
    this.onSelectPage = this.onSelectPage.bind(this);
    this.checkPermission = this.checkPermission.bind(this);
    this.onSearchInputChange = this.onSearchInputChange.bind(this);
    this.onSearch = this.onSearch.bind(this);
    this.checkHasPermission = this.checkHasPermission.bind(this);

    this.columns = [
      {
        id: 'thumbnail_url',
        title: 'Preview',
        type: 'img',
      },
      {
        id: 'name',
        title: 'Name',
      },
      {
        id: 'enabled',
        title: 'Enabled',
        type: 'bool',
      },
      {
        id: 'edit',
        title: '',
        type: 'link',
      },
    ];

    this.defaultThemeColumns = [
      {
        id: 'thumbnail_url',
        title: 'Preview',
        type: 'img',
      },
      {
        id: 'name',
        title: 'Name',
      },
      {
        id: 'edit',
        title: '',
        type: 'link',
      },
    ];
  }

  componentDidMount() {
    if (this.checkPermission(this.props, 'theme_management')) {
      this.loadThemes();
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (!this.props.themeManagementPerm) {
      return;
    }

    const isDifferentTeam = this.props.team && (!prevProps.team || prevProps.team.id !== this.props.team.id);
    const isDifferentDivision =
      this.props.division && (!prevProps.division || prevProps.division.id !== this.props.division.id);
    const isDifferentThemeManagementPermission = this.props.themeManagementPerm !== prevProps.themeManagementPerm;
    const isDifferentFilter = this.props.deleted !== prevProps.deleted;
    // Do networks requests only if necessary.
    if (isDifferentTeam || isDifferentThemeManagementPermission || isDifferentFilter || isDifferentDivision) {
      this.loadThemes();
    }
  }

  componentWillUnmount() {
    this.props.set({ dataReturned: false });
  }

  checkPermission(props, permission) {
    return props.public || (typeof props.checkPermission === 'function' && props.checkPermission(permission));
  }

  onSearchInputChange(event) {
    this.props.set({
      query: event.target.value,
    });
  }

  loadThemes(page) {
    this.props.getTeamThemes(
      this.props.team,
      this.props.division,
      this.props.query,
      this.props.deleted,
      this.props.paths,
      this.props.checkPermission,
      page || this.props.page,
      this.props.pageSize
    );
  }

  onSelectPage(page) {
    if (this.props.themeManagementPerm) this.loadThemes(page);
  }

  onSearch(event) {
    event.preventDefault();
    this.props.set({ page: 1 });
    this.loadThemes(1);
  }

  checkHasPermission(e) {
    //Remove the theme length check later
    const hasPermission =
      this.props.checkPlanPermission('custom_themes') || (this.props.themes && this.props.themes.length > 0) || false;
    if (!hasPermission) {
      e.preventDefault();
      this.props.showPaidPlanModal();
    }
  }

  render() {
    const { paths, checkPermission, division, divisions, themes, query, deleted, pageCount, page } = this.props;
    //Remove the theme length check later
    const hasPermission = this.props.checkPlanPermission('custom_themes') || (themes && themes.length > 0) || false;
    const hasThemes = Object.keys(themes).length > 0;
    const editableColumns = {
      name: {},
      enabled: {},
    };

    (defaultThemes || []).forEach((theme) => {
      const editLink = this.props.paths.newTheme;
      const themeProps = Object.assign({}, theme);
      const options = {
        pathname: editLink,
        state: {
          defaultThemeDetails: {
            id: theme.id,
            name: theme.name,
            options: theme.template,
            customCode: theme.customCode.join(''),
          },
        },
      };

      theme.href = options;
    });
    return (
      <div className="card-view pl-6 w-11/12 mb-24 themes-page">
        <Helmet>
          <title>Themes</title>
        </Helmet>
        <div className="title-container">
          <h2 className="pl-0">Themes</h2>
        </div>

        <p> Themes allow you to brand your charts in a companies style with ease.</p>

        <div className="charts-search hidden-xs space-x-4 p-4 rounded-tr-none">
          {!deleted && (
            <form onSubmit={this.onSearch} className="charts-form flex-grow flex">
              <TextInput name="search" value={query} onChange={this.onSearchInputChange} placeholder="Search themes" />

              <button type="submit" onClick={this.checkHasPermission} className="bulk-action-btn">
                {hasPermission !== undefined && !hasPermission && (
                  <span className="has-no-permission">
                    <i className="fa fa-lock"></i>
                  </span>
                )}{' '}
                Search
              </button>

              <Link onClick={this.checkHasPermission} to={this.props.paths.newTheme} className="bulk-action-btn">
                {hasPermission !== undefined && !hasPermission && (
                  <span className="has-no-permission">
                    <i className="fa fa-lock"></i>
                  </span>
                )}{' '}
                Add theme
              </Link>
            </form>
          )}

          <div className={'view-charts-btn hidden-sm hidden-md' + (deleted ? ' view-all-btn' : '')}>
            <Link
              onClick={this.checkHasPermission}
              to={deleted ? paths.profileTeamThemes : paths.profileTeamThemes + '/deleted'}
              className={'bulk-action-btn'}
            >
              {hasPermission !== undefined && !hasPermission && (
                <span className="has-no-permission">
                  <i className="fa fa-lock"></i>
                </span>
              )}
              {deleted ? ' View all themes' : ' View deleted themes'}
            </Link>
          </div>
        </div>

        {hasThemes && (
          <>
            <h3 className="mb-8">Your themes</h3>
            <div className="project-grid mb-16">
              {themes.map((theme, index) => {
                let update = (theme) => {
                  const themes = themes;
                  themes[index] = theme;
                  this.props.set({
                    themes,
                  });
                };
                return (
                  <Theme
                    key={theme.id}
                    theme={theme}
                    refresh={this.loadThemes}
                    team={this.props.team}
                    update={update}
                    isDeleted={deleted}
                    divisions={divisions}
                    hasPermission={hasPermission}
                    checkHasPermission={this.checkHasPermission}
                    showPaidPlanModal={this.props.showPaidPlanModal}
                  />
                );
              })}
            </div>
            {pageCount > 1 && ( // Display pagination if more than one page
              <div className="col-xs-12">
                <Pagination pageCount={pageCount} currentPage={page} onSelectPage={this.onSelectPage} />
              </div>
            )}
          </>
        )}

        {!deleted && (
          <>
            <h3 className="mb-8">Default themes</h3>
            <div className="project-grid">
              {defaultThemes.map((theme) => (
                <Theme
                  key={theme.id}
                  theme={theme}
                  refresh={this.loadThemes}
                  isDefaultTheme={true}
                  hasPermission={hasPermission}
                  checkHasPermission={this.checkHasPermission}
                  showPaidPlanModal={this.props.showPaidPlanModal}
                />
              ))}
            </div>
          </>
        )}
      </div>
    );
  }
}

ThemesPage.propTypes = {
  team: PropTypes.object.isRequired,
  paths: PropTypes.object.isRequired,
  checkPermission: PropTypes.func,
  deleted: PropTypes.bool,
  division: PropTypes.object,
};

export default ThemesPage;
